import { Stack } from '@mui/material';

import CustomPagination from '@hapvida/hapvida-core-components/src/components/BaseTable/components/Pagination';

import { ITEMS_LIMIT_PER_PAGE } from '@constants';

import { TotalItemsLabel } from './styles';
import type { CoparticipationPaginationProps } from './types';

export function CoparticipationPagination({
  coparticipationCount,
  handleChangePage,
  currentPage,
  total,
}: CoparticipationPaginationProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      py={2}
    >
      <TotalItemsLabel>
        Visualizando {coparticipationCount} de {total} itens
      </TotalItemsLabel>

      <CustomPagination
        count={Math.ceil(total / ITEMS_LIMIT_PER_PAGE)}
        currentPage={currentPage}
        onChange={handleChangePage}
      />
    </Stack>
  );
}
